<script lang="ts">
  import Check from "@/assets/icons/Check.svelte";
  import RightArrow from "@/assets/icons/RightArrow.svelte";

  export let theme: "primary" | "secondary" | "hollow" | "success" | "light" | "text" = "primary";
  export let size: "default" | "large" | "small" = "default";
  export let full = false;
  export let arrow = false;
  export let disabled = false;
  export let type = "button";
</script>

<button {...$$props} on:click class={`${theme} ${size} ${$$props.class}`} class:full {type} {disabled}>
  <slot name="left">
    {#if theme === "success"}
      <div class="check">
        <Check />
      </div>
    {/if}
  </slot>
  <slot />
  <slot name="right">
    {#if arrow}
      <RightArrow />
    {/if}
  </slot>
</button>

<style>
  button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-family: Montserrat;
    background: #fc3;
    border: 2px solid #fc3;
    color: #000;
    padding: 9px 20px;
    border-radius: 50px;
    text-decoration: none;
    font-size: 14px;
    line-height: 1;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease-out;
    white-space: nowrap;
  }
  .text {
    padding: 0;
  }
  .primary {
    background: #fc3;
    border: 2px solid #fc3;
    color: #000;
  }
  .primary:active,
  .primary:hover {
    background: #f3b306;
    border-color: #f3b306;
  }

  .secondary {
    background: black;
    color: white;
    border: none;
  }
  .secondary:hover {
    color: #fc3;
  }
  .hollow {
    background: #fff;
  }
  .hollow:hover {
    border-color: #f3b306;
  }
  .success,
  .success:hover {
    background: #0cb14b;
    border-color: #0cb14b;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .light {
    background: #ededed;
    border-color: #ededed;
  }
  .light:hover {
    background: #dbdbdb;
  }

  .text {
    background: transparent;
    border-color: transparent;
    color: #335cb3;
    font-weight: 600;
  }

  .text:disabled {
    background: transparent;
    border-color: transparent;
  }

  .text:disabled:hover {
    background: transparent;
    border-color: transparent;
  }

  .icon {
    display: block;
  }

  button:disabled {
    color: #979797;
    background-color: #dbdbdb;
    border: solid 2px #dbdbdb;
    cursor: not-allowed;
  }

  button:disabled:hover {
    background-color: #dbdbdb;
    border: solid 2px #dbdbdb;
    cursor: not-allowed;
  }

  .hollow:disabled {
    background-color: transparent;
    border: solid 2px #dbdbdb;
  }

  .hollow:disabled:hover {
    background-color: transparent;
    border: solid 2px #dbdbdb;
  }

  .full {
    width: 100%;
  }

  .large {
    line-height: 1.9;
  }

  .small {
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
  }
</style>
